const MODAL_TYPE = {
  ADD: 'Add',
  UPDATE: 'Update'
};

export { MODAL_TYPE };